import { render, staticRenderFns } from "./RequestRow.vue?vue&type=template&id=bfe21cfe&scoped=true"
import script from "./RequestRow.vue?vue&type=script&lang=ts"
export * from "./RequestRow.vue?vue&type=script&lang=ts"
import style0 from "./RequestRow.vue?vue&type=style&index=0&id=bfe21cfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe21cfe",
  null
  
)

export default component.exports